module.exports = __webpack_public_path__ + "img/search-icon-x.61b6a402.svg";